






































import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { Logger } from '@/Shared/Logger';
import KeyValuePair from '@/Shared/KeyValuePair';
import { Dictionary } from 'vue-router/types/router';
import ClipboardMixin from '@/Shared/ClipboardMixin';
import I18nMixin from '@/Shared/I18nMixin';

export default mixins(ClipboardMixin, I18nMixin).extend({
    name: 'KeyValuePairGrid',
    props: {
        keyValuePairs: {
            required: true,
            type: Array as () => KeyValuePair[]
        }
    },
    computed: {
        keyValuePairsJSON() {
            const convertedObject = (this.keyValuePairs as KeyValuePair[])
                                    .reduce((acc: {[key: string]: string}, current, index) => {
                                        acc[current.key] = current.value;
                                        return acc;
                                    }, {});
            return JSON.stringify(convertedObject);
        },
        i18nPrefix() {
            return 'shared.keyValuePairGrid';
        }
    }
});
